import { useController } from '../hooks/useController'
import { CompleteScreen } from './CompleteScreen'
import { Step1 } from './Step1'
import { Step2 } from './Step2'

export function Body() {
  const {
    data: { progress },
  } = useController()

  if (progress === 'completed') return <CompleteScreen />
  if (typeof progress === 'number' && progress > 50) return <Step2 />
  return <Step1 />
}
